var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup26(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.688,
    height: 171.861,
    viewBox: "0 0 148.688 171.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-662.021 -1295.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M1847.505,295.651h-71.7a19.331,19.331,0,0,0-19.338,19.33v18.993h-18.992a19.331,19.331,0,0,0-19.33,19.338v94.861a19.337,19.337,0,0,0,19.33,19.339h71.707a19.336,19.336,0,0,0,19.329-19.339V429.181h18.993a19.329,19.329,0,0,0,19.329-19.33v-94.87a19.329,19.329,0,0,0-19.329-19.33M1818.274,426.24a10.921,10.921,0,0,1-.4,2.941,11.106,11.106,0,0,1-10.718,8.173H1739.5a11.108,11.108,0,0,1-11.114-11.114V358.393a11.108,11.108,0,0,1,11.114-11.114h67.662a11.108,11.108,0,0,1,11.114,11.114Zm38.331-38.322a11.121,11.121,0,0,1-11.122,11.114h-16.971v-45.72a19.33,19.33,0,0,0-19.329-19.338h-42.477V320.062a11.119,11.119,0,0,1,11.114-11.114h67.663a11.121,11.121,0,0,1,11.122,11.114Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26);
export default __webpack_public_path__ + "static/media/Group 26.49aff4f1de1a5cba865b5406e61f1639.svg";
export { ForwardRef as ReactComponent };